exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container-images[data-v-a2929d80]{width:100%;display:flex;flex-wrap:wrap;justify-content:center;max-height:400px;overflow-y:auto\n}\n.img-folder[data-v-a2929d80]{width:300px;height:150px;margin:5px;object-fit:contain\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-a2929d80","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/upload/PopUpImages.vue
// module id = 158
// module chunks = 0